/**
 * Endpoints del catálogo de módulos.
 *
 * La segmentación por categorías y los permisos se resuelven en el backend
 * (tablas `modulo_categorias`, `modulos`, `plan_modulos` + grupos del usuario).
 */

import { apiClient } from '@/lib/http/api-client';

import type { CatalogoModulos } from './modulos.types';

export const modulosKeys = {
  all: ['modulos'] as const,
  disponibles: ['modulos', 'disponibles'] as const,
};

export const modulosApi = {
  /** Categorías y módulos habilitados para el usuario autenticado. */
  disponibles: (signal?: AbortSignal): Promise<CatalogoModulos> =>
    apiClient.get<CatalogoModulos>('/api/modulos_disponibles', { signal }),
} as const;
